"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legal = void 0;
var internal_1 = require("./internal");
exports.legal = {
    brokerMandate: internal_1.contentBucketUrl + "/legal/sample-broker-mandate.pdf",
    introductoryInformation: internal_1.contentBucketUrl + "/legal/Information%20nach%20%C2%A7%2011%20Versicherungsvermittlungsverordnung%20VersVermV.pdf",
    declarationDataProtection: internal_1.contentBucketUrl + "/legal/shared/Declaration%20of%20Data%20Protection%20and%20Confidentiality%20Release%20Policies%20English.pdf",
    referralEngineTermsAndConditions: internal_1.contentBucketUrl + "/legal/referral-engine/Referral%20program%20terms%20(German%20%26%20English)%20-%202%20column.pdf",
};
